/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useBreakingStore = defineStore("breaking", {
  actions: {
    async j6ListFetch(payload) {
      const body = {
        page: {},
        filter: {
          cusUid: payload.cusUid,
          refNumber: payload.refNumber,
          j6Uid: payload.j6Uid,
          priCatUid: payload.priCatUid,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/j6/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async OverdueListFetch(payload) {
      const body = {
        page: {},
        filter: {
          period: payload.period,
          cusUid: payload.cusUid,
          refNumber: payload.refNumber,
          priCatUid: payload.priCatUid,
          postpone: payload.postpone,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/overdue/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async BreakingListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {},
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async historyListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          catUid: payload.catUid, // priority cat uid
          cusUid: payload.cusUid,
          tkRefNumber: payload.tkRefNumber,
          stockNo: payload.stockNo,
          lotNumber: payload.lotNumber,
          action: payload.action, // empty for all actions, BREAKING, SCAN_OUT, ESTIMATION_COMPLETE, SCAN_IN
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/history/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
